export default "__VITE_ASSET__CSaHw7FL__"